import { Star } from '@mui/icons-material'
import { ListItemText, Typography } from '@mui/material'
import DatasetsIcon from 'images/datasets.svg'
import { StaticFolders } from 'pages/datasets/context/types'
import { Folder } from 'pages/datasets/types'
import { Folders } from './folders'
import { DatasetMenuItem } from './menuItem'
import * as css from './styles'
import { useFolderHeight } from './useFolderHeight'
import { t } from '@lingui/core/macro'

interface Props {
  folders: Folder[]
  setSelectedMenuItem: (item: string) => void
  selectedMenuItem: string | number | null
}

export const DatasetMenu = ({ folders, setSelectedMenuItem, selectedMenuItem }: Props) => {
  const { datasetMenuRef, menuHeight, setFolderRef, getDatasetMenuRef } = useFolderHeight()

  const isSelectedDatasets = selectedMenuItem === StaticFolders.all
  const isSelectedFavorites = selectedMenuItem === StaticFolders.favorites

  return (
    <css.Section ref={datasetMenuRef}>
      <DatasetMenuItem
        key={StaticFolders.all}
        isSelected={isSelectedDatasets}
        onSelected={() => {
          setSelectedMenuItem(StaticFolders.all)
        }}
        text="Datasets"
        className="-all-dataset-menu-item"
        icon={<DatasetsIcon />}
      />
      <DatasetMenuItem
        key={StaticFolders.favorites}
        isSelected={isSelectedFavorites}
        onSelected={() => {
          setSelectedMenuItem(StaticFolders.favorites)
        }}
        text="Favorites"
        className="-favorites-dataset-menu-item"
        icon={<Star className="mui-icon-star" />}
      />
      <css.GreyBar />
      <css.MenuItem key="Folders">
        <css.FolderItem>
          <ListItemText primary={<Typography css={css.boldTypography}>{t`Folders`}</Typography>} />
        </css.FolderItem>
      </css.MenuItem>
      <Folders
        ref={ref => {
          setFolderRef(ref)
        }}
        folders={folders}
        onSelected={setSelectedMenuItem}
        selectedMenuItem={selectedMenuItem}
        height={menuHeight}
        getDatasetMenuRef={getDatasetMenuRef}
      />
    </css.Section>
  )
}
